const es = {
    common: {
        history: "versión histórica"
    }
};
export default es;



// WEBPACK FOOTER //
// ./src/i18n/langs/es.js